(() => {
  const sameTabTargets = new Set(['', '_self', '_top']);

  const getTarget = (hash) => {
    if (!hash || hash === '#') return null;

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return document.getElementById(hash.slice(1));
    }
  };

  const getHeaderOffset = () => {
    const styles = getComputedStyle(document.documentElement);
    const header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
    const announcement = parseFloat(styles.getPropertyValue('--announcement-height')) || 0;

    return header + announcement + 16;
  };

  const scrollToTarget = (target) => {
    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');

    if (!link || link.hasAttribute('download') || !sameTabTargets.has(link.target)) return;

    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

    const target = getTarget(url.hash);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target);

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', url.hash);
    } else {
      window.location.hash = url.hash.slice(1);
    }
  });

  window.addEventListener('load', () => {
    const target = getTarget(window.location.hash);
    if (!target) return;

    window.requestAnimationFrame(() => scrollToTarget(target));
  });
})();
